import { DeviceStateFlag } from '@racemap/utilities/consts/events';
import type { Geofence, PreparedStarterInfo } from '@racemap/utilities/functions/timing';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { FC, ReactNode } from 'react';
import { testStarterHasValidStartFlag } from '../../../utils/helpers';
import type { Column } from '../TableBody';
import { Cell } from './BasicCell';

const DeviceStateLabel: Record<string, string> = {
  [DeviceStateFlag.DIDNOTSTART]: 'did not start',
  [DeviceStateFlag.DIDNOTFINISH]: 'did not finished',
  [DeviceStateFlag.DISQUALIFIED]: 'disqualified',
};

interface Props {
  starterInfo: Immutable<PreparedStarterInfo>;
  event: Immutable<RacemapEvent>;
  timekeepings: Immutable<Array<Geofence>>;
}

const RankColComponent: FC<Props> = ({ starterInfo, event, timekeepings }) => {
  const disabledLiveRankingWithoutFinish =
    !event.modules.timing.liveRanking && starterInfo?.results[timekeepings.length - 1] == null;
  const withoutStart = starterInfo?.results[0] == null;

  return (
    <Cell
      title={starterInfo.state != null ? DeviceStateLabel[starterInfo.state] : ''}
      style={{ opacity: starterInfo.state === DeviceStateFlag.DISQUALIFIED ? 0.7 : 1 }}
    >
      {testStarterHasValidStartFlag(starterInfo)
        ? starterInfo?.state
        : disabledLiveRankingWithoutFinish || withoutStart
          ? DeviceStateFlag.NORANK
          : starterInfo?.rank}
    </Cell>
  );
};

export function rankCol(
  event: Immutable<RacemapEvent>,
  timekeepings: Immutable<Array<Geofence>>,
): Column {
  return {
    key: 'rank',
    title: 'Rank',
    width: 50,
    render: function renderer(row: Immutable<PreparedStarterInfo>): ReactNode {
      return <RankColComponent starterInfo={row} event={event} timekeepings={timekeepings} />;
    },
    sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>): number => {
      if (testStarterHasValidStartFlag(a)) {
        if (testStarterHasValidStartFlag(b)) {
          return b.progress - a.progress;
        }
        return 1;
      }
      if (testStarterHasValidStartFlag(b)) {
        return -1;
      }
      return a.rank - b.rank || b.progress - a.progress;
    },
  };
}
